import { RootState } from '../../../../../init-store';
import { getParticipantByIds } from '../../../../pages/call/selectors';
import { SELF } from '../../../constants';
import { selectSyncStateWithPeerId } from '../../config/selectors';

export const selectIsSelfAudioMuted = (state: RootState) => {
    const participantByIds = getParticipantByIds(state);

    return Boolean(participantByIds[selectSyncStateWithPeerId(state) || SELF]?.audio?.muted);
};

export const selectIsSelfVideoMuted = (state: RootState) => {
    const participantByIds = getParticipantByIds(state);

    return Boolean(participantByIds[selectSyncStateWithPeerId(state) || SELF]?.video?.muted);
};
